
      // Show dev mode banner
      if (import.meta.env.DEV) {
        const banner = document.createElement('div');
        banner.className = 'dev-mode-banner';
        banner.textContent = '🛠️ Development Mode - Errors will be displayed prominently';
        document.body.prepend(banner);
      }

      // Handle critical errors before React loads
      window.onerror = function(message, source, lineno, colno, error) {
        const errorDiv = document.createElement('div');
        errorDiv.className = 'react-error-overlay';
        errorDiv.innerHTML = `
          <div class="react-error-content">
            <h2 class="react-error-title">⚠️ Critical Error</h2>
            <p style="margin-bottom: 16px; color: #fbbf24;">
              A critical error occurred before React could initialize. This may indicate a build or configuration issue.
            </p>
            <div class="react-error-message">
Error: ${message}
Source: ${source}:${lineno}:${colno}
${error ? 'Stack: ' + error.stack : ''}
            </div>
            <button onclick="location.reload()" class="react-error-dismiss">
              Reload Page
            </button>
          </div>
        `;
        document.body.appendChild(errorDiv);
        return true; // Prevent default error handling
      };

      // Handle unhandled promise rejections
      window.onunhandledrejection = function(event) {
        console.error('Unhandled Promise Rejection:', event.reason);
      };
    